import {
  EpkModuleApiService,
  getFilteredData,
} from '~packages/epk-front-shared/api-client';
import type { Filters, Params } from '~packages/epk-front-shared/api-client';
import { Mode, RequestMethod } from '~packages/json-api/client';

import getConstants from '@/shared/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'AccountsApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  needInit: isModeDevelopment,
};

export default class AccountsApiService extends EpkModuleApiService {
  constructor() {
    super(constructorParams);
  }

  async getAll(params: any) {
    return await super.fetchAll(params);
  }

  async getByCode(code: string) {
    return await super.fetch('one/' + code);
  }

  async getFilteredData(filters: Filters, params: Params) {
    return await getFilteredData(this, filters, params);
  }

  async getOktmos() {
    this.pathFetchAll = '/valid-oktmos';
    return await super.fetchAll();
  }

  async getAllOktmos(path: string) {
    return await super.fetch(path);
  }

  async deleteByCode(code: string) {
    return await this._sendRequest(
      `/${code}`,
      undefined,
      { method: RequestMethod.DELETE },
      { method: 'delete' }
    );
  }

  async getRelated(code: string) {
    return await this._sendRequest(
      `/${code}/related`,
      undefined,
      { method: RequestMethod.GET },
      { method: 'related' }
    );
  }

  async updateRlph(data: any) {
    return await this._sendRequest(
      `/update/rlph`,
      undefined,
      { body: this.jsonStringify(data), method: RequestMethod.PUT },
      { method: 'updateRlph' }
    );
  }
}
